<template>
  <div class="content">
    <Header></Header>
    <div class="contentbox flex flex-grow">
      <Sidebar v-if="token"></Sidebar>
      <div class="main">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Sidebar from '@/components/sidebar/sidebar.vue'
import Header from '@/components/header/header.vue'
export default {
  components: {
    Sidebar,
    Header,
  },
  computed: {
    ...mapGetters(['token']),
  },
}
</script>

<style lang="scss" scoped>
// div {
//   user-select: none;
// }
.content {
  background: #f3f4f7;
  overflow: hidden;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex: 1;
  flex-direction: column;
}
.contentbox {
  margin: 0 auto;
  height: 100%;
}
.main {
  box-sizing: border-box;
  background: #f3f4f7;
  position: relative;
  overflow-y: auto;
  height: 100%;
  width: 73.94rem;
  // flex: 1;
  padding-bottom: 4rem;
}
</style>
